import { render, staticRenderFns } from "./DeliverableListTags.vue?vue&type=template&id=01d93bd4&"
import script from "./DeliverableListTags.vue?vue&type=script&lang=js&"
export * from "./DeliverableListTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports